//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import ToastView from "./toast_view";


enum toastState{
    down,
    stay,
    up,
}

class toastAction{

    private _node : cc.Node;
    public get node(){
        return this._node;
    }
    
    private _text : string;
    public get text() : string {
        return this._text;
    }
    
    private finished : cc.ActionInstant;

    private state : toastState = toastState.down;

    private needStay : boolean;

    constructor(node : cc.Node,text : string) {
        this._node = node;
        this._text = text;
    }

    public run( finished : cc.ActionInstant,needStay :boolean = true){

        let downMove = cc.moveBy(0.5,cc.v2(0,-130));

        this.state = toastState.down;
        this.needStay = needStay;
        
        this.finished = finished;
     
        this._node.runAction(cc.sequence(downMove,this.downFinished()));
      }

    private downFinished(){

        let self = this;
        return cc.callFunc(function (target) {
            self.state = toastState.stay;      
            self._node.runAction(cc.sequence(cc.delayTime(self.needStay? 3: 0),self.stayFinished()));
        });
    }

    private stayFinished(){

        let upMove = cc.moveBy(0.5,cc.v2(0,130));

        let self = this;
        return cc.callFunc(function (target) {
            self.state = toastState.up;
            self._node.runAction(cc.sequence(upMove,self.finished));
        });
    }    

    /**
     * 移除停留状态
     */
    public removeStay(){
        let upMove = cc.moveBy(0.5,cc.v2(0,130));

        if (this.state == toastState.down) {
            this.needStay = false;
        }
        else if(this.state == toastState.stay){
            this._node.stopAllActions();
            this.state = toastState.up;          
            this._node.runAction(cc.sequence(upMove,this.finished));  
        }            
    }
}

@ccclass
@moduleInit("Toast")
export default class Toast extends ModuleBase<ToastView, null> {

    private itemPool  : cc.NodePool;
    private currentItem : toastAction = null;

    //等待队列
    private waitQueue : toastAction[] = [];

    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.High;
        this.windowPrefabResPath = "package/public/public_toast";
        this.viewType = ToastView;
    }

    private gestureStart : cc.Vec2;
  
    onLoad(){
        this.itemPool = new cc.NodePool();
    }

    private touchStart(event){

        this.gestureStart = event.touch.getLocation();
    }

    private touchCheck(event : cc.Event.EventTouch){

        let gestureEnd = event.touch.getLocation();

        let dir = new cc.Vec2(gestureEnd.x - this.gestureStart.x,
                              gestureEnd.y - this.gestureStart.y);
                
                                
        let angle = Math.abs(dir.angle(cc.Vec2.UP) * 180 / Math.PI);
        let dis = dir.mag();
        if (angle < 45 && dis > 50 ) {
            if (this.currentItem) {
                this.currentItem.removeStay();
            }
        }
    }



    onShow(intentData?: any) {
        if (intentData && typeof (intentData) == "object") {
            let text = intentData.text
            let long = intentData.long
            //this._show(text, long)
            this.createItem(text);
        } else {
            //this._show(intentData)  
            this.createItem(intentData);                  
        } 
    }

    // _show(text, long?: boolean) {
    //     let node = cc.instantiate(this.view.holder);
    //     this.view.node.addChild(node)
    //     let spriteBackground = node.getChildByName("SpriteBackground").getComponent(cc.Sprite)
    //     let textLabel = node.getChildByName("Label").getComponent(cc.Label)
    //     textLabel.string = text;
    //     cc.log(" toast text " , text);
    //     //@ts-ignore
    //     //if (!CC_JSB) {
    //         textLabel._forceUpdateRenderData(true)//刷新Label宽高度   
    //     //}        
    //     spriteBackground.node.width = textLabel.node.width < 400 ? 400 : textLabel.node.width + 300;
    //     spriteBackground.node.height = textLabel.node.height < 60 ? 60 : textLabel.node.height + 30;
    //     let finished = cc.callFunc(function (target) {
    //         // node.destroy();
    //     }, this);
    //     // let time1 = 0.5
    //     // let time2 = 0.3
    //     let time1 = 1
    //     let time2 = 0.6
    //     if (long) {
    //         time1 = 1
    //         time2 = 0.6
    //     }

        

    //     //需求变更：不向上飘动
    //     let action = cc.sequence(cc.moveBy(time1, cc.v2(0, 0)), cc.fadeOut(time2), finished);
    //     node.runAction(action);
    // }    

    private createItem(text : string){
        let item : cc.Node = null;

        if (this.currentItem) {
            if (this.currentItem.text == text) {
                //内容相同就不创建item
                return;
            }
        }
        if (this.waitQueue.length > 0) {
            //取最近添加的一条         
            let toast = this.waitQueue[this.waitQueue.length - 1]
            if (toast.text == text) {
                return;
            }
        }

        if (this.itemPool.size() > 0) {
            item = this.itemPool.get();

        }else{
            item = cc.instantiate(this.view.item);
        }

        item.parent = this.view.node;
        item.active = true;
        let textLab = item.getChildByName("textLabel").getComponent(cc.Label);
        if (!textLab) {
            item.destroy();
            cc.error(" toast textLabel has not label component !");            
            return;
        }

        let widget = item.getComponent(cc.Widget);
        widget.enabled = true;

        textLab.string = text;

        if (this.currentItem) {

            this.currentItem.removeStay();
            let toastAct = new toastAction(item,text);            
            this.waitQueue.push(toastAct);
        }
        else{
            
            this.run(new toastAction(item,text))
        } 
    }

    private run(toastAct : toastAction,needStay  :boolean = true){

        let finished = cc.callFunc(this.itemFinished.bind(this,toastAct.node))
        toastAct.run(finished,needStay);
                        
        this.currentItem = toastAct;

        this.currentItem.node.on(cc.Node.EventType.TOUCH_START,this.touchStart,this);
        this.currentItem.node.on(cc.Node.EventType.TOUCH_END,this.touchCheck,this);
        this.currentItem.node.on(cc.Node.EventType.TOUCH_CANCEL,this.touchCheck,this);
       
    }

    private itemFinished(item : cc.Node){

        if (this.currentItem.node != item) {            
            cc.error(" toast createItem error !");            
        }

        item.targetOff(this);
        this.itemPool.put(item);        
        this.currentItem = null;

        if (this.waitQueue.length > 0) {

            let toastAct = this.waitQueue.shift();
            this.run(toastAct,this.waitQueue.length == 0);
        }
    }

}